import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { AdminHeaderButton } from "@interfaces/adminHeaderButton.interface";
import { Client } from "@interfaces/models/client.interface";
import { ClientLocation } from "@interfaces/clientLocation.interface";
import { InvoiceGridRow } from "@interfaces/invoiceGridRow.interface";
import { LogExport } from "@interfaces/logExport.interface";
import { UserProfile } from "@interfaces/userProfile.interface";
import { ClientService } from "@services/client.service";
import { ClientLocationService } from "@services/clientLocation.service";
import { ExportLogService } from "@services/exportLog.service";
import { InvoiceService } from "@services/invoice.service";
import { ProtectedGridService } from "@services/protectedGrid.service";
import { UserProfileService } from "@services/userProfile.service";
import { ToastService } from "angular-toastify";

@Component({
	moduleId: module.id,
	selector: "invoices-deleted",
	styleUrls: ["invoices-deleted.css"],
	templateUrl: "invoices-deleted.html"
})
export class InvoicesDeletedAdminComponent {
	canExportGrid = false;
	clientLocations: ClientLocation[] = [];
	clients: Client[] = [];
	gridLoading = false;
	headerPrimaryButtons: AdminHeaderButton[] = [{ method: "viewInvoices", text: "View Invoices" }];
	headerSecondaryButtons: AdminHeaderButton[] = [];
	itemType = "Invoice"
	itemUrl: string = location.href.split("/")[3] + "/" + location.href.split("/")[4];
	items: InvoiceGridRow[] = [];
	title: string;
	userProfiles: UserProfile[] = [];
	
	constructor(private router: Router, private toastService: ToastService, private itemService: InvoiceService, private clientService: ClientService, private clientLocationService: ClientLocationService, private exportLogService: ExportLogService, private protectedGridService: ProtectedGridService, private userProfileService: UserProfileService) {
		this.title = "Deleted Invoices";
		this.generatePreviewPDF = this.generatePreviewPDF.bind(this);
		this.viewInvoices = this.viewInvoices.bind(this);
		this.viewRow = this.viewRow.bind(this);
		this.viewSalesOrder = this.viewSalesOrder.bind(this);
		
		this.getItems();
		this.getClients();
		this.getClientLocations();
		this.getUserProfiles();
		this.checkGridExportPermissions();
	}
	
	checkGridExportPermissions() {
		this.protectedGridService.canExport("Deleted Invoices")
			.subscribe(
				(res: any) => {
					this.canExportGrid = res.response;
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				},
			);
	}

	generatePreviewPDF(e: any) {
		this.itemService.generateAndPreviewPdf(e.row.data.id).subscribe(
			(response: any) =>{
				const dataType = response.type;
				const binaryData = [];
				binaryData.push(response);
				const downloadLink = document.createElement("a");
				downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, {type: dataType}));
				downloadLink.setAttribute("download", "INV" + e.row.data.id + "-" + this.clients.find(x => x.id == e.row.data.clientId)?.name +  ".pdf");
				document.body.appendChild(downloadLink);
				downloadLink.click();
			}
		);
	}
	
	getClientLocations() {
		this.clientLocationService.getAll()
			.subscribe(
				(res: any) =>  {
					this.clientLocations = res.response.items;
				},
				(err) => console.log(err)
			);
	}
	
	getClients() {
		this.clientService.getAll()
			.subscribe(
				(res: any) =>  {
					this.clients = res.response.items;
				},
				(err) => console.log(err)
			);
	}

	getItems() {
		this.gridLoading = true;
		this.itemService.getDeleted()
			.subscribe(
				(res: any) => {
					this.items = res.response;
					this.gridLoading = false;
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				},
			);
	}

	getUserProfiles(){
		this.userProfileService.getAllWithUsers()
			.subscribe(
				(res: any) => {
					this.userProfiles = res.response;
				},
				(err) => { console.log(err); this.toastService.error("Something Went Wrong!"); }
			);
	}

	headerButtonClick(method: any) {
		// @ts-ignore // Required to be able to call the method directly from the variable
		if (this[method]) this[method]();
	}

	logExport() {
		const logExport = new LogExport();
		logExport.gridName = "Deleted Invoices";
		this.exportLogService.logExport(logExport)
			.subscribe(
				() => console.log("Export Logged"),
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
					return false;
				},
			);
	}

	viewInvoices() {
		this.router.navigate([`${this.itemUrl}`]);
	}

	viewRow(e: any) {
		this.router.navigate([`${this.itemUrl}/${e.row.data.lookupId}`]);
	}

	viewSalesOrder(e: any) {
		this.router.navigate([`admin/salesOrders/${e.row.data.salesOrderLookupId}`]);
	}
}